module.exports = __webpack_public_path__ + "static/media/influencer.918cf3ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/influencer.svg
// module id = 1947
// module chunks = 0